module.exports = __webpack_public_path__ + "static/media/EIL.3da34dc0.png";